import { useQuery } from '@tanstack/react-query';
import {
  getThreads,
  getThreadParticipants,
  type ThreadFilters,
} from '../../services';

export const threadKeys = {
  all: ['threads'] as const,
  lists: () => [...threadKeys.all, 'list'] as const,
  list: (filters: ThreadFilters) =>
    [...threadKeys.lists(), { ...filters }] as const,
  participants: (threadId: number) =>
    [...threadKeys.all, 'participants', threadId] as const,
};

export function useThreads(filters: ThreadFilters) {
  return useQuery({
    queryKey: threadKeys.list(filters),
    queryFn: () => getThreads(filters),
    enabled: !!filters.school,
  });
}

/**
 * Lazy-load participants for the protocol-drawer member-peek
 * popover. Pass `enabled: false` until the popover opens so the
 * request fires only on demand. The cache key is per-thread, so
 * reopening the same popover within React-Query's 5-minute window
 * skips the network round trip.
 */
export function useThreadParticipants(
  threadId: number | null,
  enabled: boolean,
) {
  return useQuery({
    queryKey: threadKeys.participants(threadId ?? 0),
    queryFn: () => getThreadParticipants(threadId as number),
    enabled: enabled && threadId != null,
    staleTime: 5 * 60 * 1000,
  });
}
